import { useState } from "react";
import { UserContext } from "./OrderContext";

export default function UserProvider({ children }) {

    const [orderMSG, setOrderMSG] = useState();
    const [orderCode, setOrderCode] = useState();

    return (
        <UserContext.Provider value={{ orderMSG, setOrderMSG, orderCode, setOrderCode }}>
            {children}
        </UserContext.Provider>
    );
}